var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('payment-status',{staticClass:"float-right mt-1",attrs:{"booking":_vm.booking}}),_c('h1',[_vm._v(" "+_vm._s(_vm._f("currency")(_vm.booking.remainingTotal))+" ")]),_c('div',{staticClass:"py-2 my-3"},[_vm._v(_vm._s(_vm.paymentStatusMessage))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }